<template>
  <CCard v-if="sipUser" role="button" @click="$emit('click')">
    <CCardBody class="px-3 py-2">
      <div class="form-row">
        <div class="col-1">
          <img
            v-if="sipUser.Email"
            :src="`${$http.defaults.baseURL}/Document/download/Employees/${sipUser.Email}.jpg`"
            class="rounded-circle w-100"
            @error="replaceByDefault"
          />
          <img v-else src="/img/avatar.png" class="rounded-circle w-100" />
        </div>
        <div class="col-11">
          <div class="rounded-pill bg-light p-3">
            <h6 class="mb-0 text-info">Start a new idea!</h6>
          </div>
        </div>
      </div>
      <div class="form-row mt-2 text-center" style="font-size: 1rem">
        <div class="col text-info">
          <i class="fas fa-globe"></i>
          Topic
        </div>
        <div class="col text-success">
          <i class="fas fa-image"></i>
          Attachments
        </div>
      </div>
    </CCardBody>
  </CCard>
</template>

<script>
export default {
  computed: {
    sipUser() {
      let sipUser = localStorage.getItem("sipUser");
      if (sipUser) {
        return JSON.parse(sipUser);
      } else {
        return null;
      }
    },
  },
  methods: {
    replaceByDefault(e) {
      e.target.src = "/img/avatar.png";
    },
  },
};
</script>
